import { render, staticRenderFns } from "./ModalBot.vue?vue&type=template&id=170323d1&scoped=true"
import script from "./ModalBot.vue?vue&type=script&lang=js"
export * from "./ModalBot.vue?vue&type=script&lang=js"
import style0 from "./ModalBot.vue?vue&type=style&index=0&id=170323d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170323d1",
  null
  
)

export default component.exports